import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Activity } from "lucide-react";

function timeAgo(iso, locale) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(locale, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

export default function ActivityPage() {
  const { t, lang } = useI18n();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/activity").then(({ data }) => setLogs(data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="activity-page">
      <div>
        <h1 className="text-3xl font-extrabold text-white">{t("dash.pages.activity.title")}</h1>
        <p className="mt-1 text-white/55">{t("dash.pages.activity.desc")}</p>
      </div>

      <div className="rounded-lg border border-white/10 bg-[#0a0a0a] divide-y divide-white/5">
        {logs.length === 0 && <p className="p-6 text-sm text-white/40">{t("dash.pages.activity.empty")}</p>}
        {logs.map((l) => (
          <div key={l.id} className="flex items-start gap-4 p-5" data-testid="activity-item">
            <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-md border border-[#EAB308]/25 bg-[#EAB308]/10 shrink-0">
              <Activity className="w-4 h-4 text-[#EAB308]" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-medium text-white">{l.action}</span>
                <span className="text-xs text-white/35 font-mono shrink-0">{timeAgo(l.created_at, lang === "en" ? "en-CA" : "fr-CA")}</span>
              </div>
              {l.detail && <p className="mt-0.5 text-sm text-white/50">{l.detail}</p>}
              <p className="mt-0.5 text-xs text-white/30">{t("dash.pages.activity.by")} {l.user_name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
